import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconToolbox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconToolbox"><Path fillRule="evenodd" clipRule="evenodd" d="M6.05203 2H7.94797L10 5.81091V10H12V2H20V10H22V21H2V10H4V5.81091L6.05203 2ZM8.5 10H5.5V6.18909L6.94797 3.5H7.05203L8.5 6.18909V10ZM13.5 10H18.5V3.5H13.5V6H16V7.5H13.5V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconToolbox;
